import React, { FC } from 'react';

const SortAscIcon: FC<{ className?: string }> = ({ className }) => {
  return (
    <svg
      className={className}
      width="8"
      height="12"
      viewBox="0 0 8 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.43238 0.786516C3.71178 0.399375 4.28822 0.399375 4.56762 0.786516L6.66329 3.69036C6.99739 4.15331 6.66659 4.8 6.09567 4.8H1.90433C1.33341 4.8 1.00261 4.15331 1.33671 3.69036L3.43238 0.786516Z"
        fill="black"
      />
      <path
        d="M3.43238 10.4134C3.71178 10.8006 4.28822 10.8006 4.56762 10.4134L6.66329 7.50959C6.99739 7.04664 6.66659 6.39995 6.09567 6.39995H1.90433C1.33341 6.39995 1.00261 7.04664 1.33671 7.50959L3.43238 10.4134Z"
        fill="#CCCCCC"
      />
    </svg>
  );
};

export default SortAscIcon;
